import type { StaffingChangeSummary } from '../operations/model';
import { ChangeSummary, ValueBadge, type ChangeSummaryProps } from '../../../design-system';

export type ChangeComparisonProps = {
  changes: NonNullable<StaffingChangeSummary['changes']>;
  layout?: ChangeSummaryProps['layout'];
  mode?: ChangeSummaryProps['mode'];
};

export function ChangeComparison({ changes, layout, mode }: ChangeComparisonProps) {
  return <ChangeSummary layout={layout} mode={mode} testId="change-comparison" emptyValue={layout === 'rows' || layout === 'inline' ? '없음' : '-'} items={changes.map((change) => {
    const badge = layout !== 'inline' && ['status', 'jobType', 'timeType', 'jobLevel'].includes(change.field);
    return {
      id: change.field,
      label: change.label,
      before: badge && change.before && change.before !== '-' ? <ValueBadge label={change.before} /> : change.before,
      after: badge && change.after && change.after !== '-' ? <ValueBadge label={change.after} /> : change.after,
    };
  })} />;
}
